import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import DataWrapper from "./Components/DataWrapper";
import * as serviceWorker from "./serviceWorker";
const root = ReactDOM.createRoot(document.getElementById("root")); // ✅ Only pass the DOM element

root.render(
  <React.StrictMode>
    <DataWrapper /> {/* ✅ Ensure you use your main component */}
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
